<template>

    <!-- Remove Profile Modal Start -->
    <div class="modal fade theme-modal remove-profile" :id="id" tabindex="-1"
         :aria-labelledby="id + 'Label' " aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
            <div class="modal-content">
                <div class="modal-header d-block text-center">
                    <h5 class="modal-title w-100 p-4" :id="id + 'Label' ">
                        {{ message }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="modal-footer d-flex justify-content-center">
                    <button type="button" class="btn btn-animation btn-md fw-bold" data-bs-dismiss="modal">No</button>

                    <button type="button" class="btn theme-bg-color btn-md fw-bold text-light"
                            data-bs-target="#removeAddress" data-bs-toggle="modal"  @click="$emit('confirm')">Yes</button>
                </div>
            </div>
        </div>
    </div>

<!--    -->
<!--    <div v-if="show" class="modal">-->
<!--        <div class="modal-content">-->
<!--            <p>{{ message }}</p>-->
<!--            <div class="modal-buttons">-->
<!--                <button @click="$emit('confirm')">Yes</button>-->
<!--                <button @click="$emit('cancel')">No</button>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
</template>

<script>
export default {
    props: {
        message: String,
        id : String
    }
};
</script>

<style scoped>
/* Your modal styles here */
</style>
